var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11ZM16.5145 12.3927C16.0409 12.1085 15.4267 12.2621 15.1425 12.7357C14.3314 14.0875 12.6649 15.0002 11 15.0002C9.33518 15.0002 7.66864 14.0875 6.85752 12.7357C6.57337 12.2621 5.95911 12.1085 5.48553 12.3927C5.01195 12.6768 4.85839 13.2911 5.14254 13.7646C6.32078 15.7284 8.64314 17.0002 11 17.0002C13.3569 17.0002 15.6793 15.7284 16.8575 13.7646C17.1417 13.2911 16.9881 12.6768 16.5145 12.3927ZM14.0044 6C14.5567 6 15.0044 6.44772 15.0044 7C15.0044 7.51284 14.6184 7.93551 14.121 7.99327L14.0044 8C13.4477 8 13 7.55228 13 7C13 6.48716 13.386 6.06449 13.8834 6.00673L14.0044 6ZM9.00439 7C9.00439 6.44772 8.55668 6 8.00439 6L7.88338 6.00673C7.38604 6.06449 7 6.48716 7 7C7 7.55228 7.44772 8 8.00439 8L8.12101 7.99327C8.61835 7.93551 9.00439 7.51284 9.00439 7Z",
    fill: "#78264F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.eec1d429.svg";
export { ForwardRef as ReactComponent };